// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import Loader from '../../../../components/Utils/Loader'
import InstallersList from "../../../../components/Installers/InstallersList";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postSearchInstallers = endpointHelias+"/Helias/V0/Configuration/postSearchInstallers"

var initialConfigCommonJS = require("../../../../js/initialConfigCommon.js");
var dashboardCommonJS = require("../../../../js/dashboardCommon.js")

// Initial config - Meteo
const ShareWithInstaller = (params) => {

  const [listadoInstaladores, setListadoInstaladores] = useState([])

  useEffect(() => {        

    if(document.getElementById("textoBuscador").value === ""){
      document.getElementById("divSinResultadosInstaladores").className += " hidden"
    }
    else{
      if(document.getElementById("divSinResultadosInstaladores") !== null){
        document.getElementById("divSinResultadosInstaladores").className = document.getElementById("divSinResultadosInstaladores").className.replaceAll(" hidden", "")
      }      
    }

    console.log("Página para compartir con instalador cargada correctamente.")
  }, [listadoInstaladores]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {      
      buscarInstalador()
    }
  } 

  function buscarInstalador(){

    if(document.getElementById("textoBuscador").value.length > 3){

      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
      
      document.getElementById("loaderShareInstallation").className = "loader overlay"
      
      //Petición de datos para el paso actual
      var jsonPeticion = {
        "nombreInstalador": document.getElementById("textoBuscador").value
      }
    
      // Guardo la información  
      var xhttp = new XMLHttpRequest();  
        xhttp.open("POST", postSearchInstallers, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify(jsonPeticion);
        xhttp.onreadystatechange = function() {
          
          if (this.readyState === 4 && this.status === 200) {
            var jsonRespuesta = JSON.parse(this.responseText)
            if(jsonRespuesta.statusCode === "403"){                   
              initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
            }
            else{         
              setListadoInstaladores(jsonRespuesta.body)
              document.getElementById("loaderShareInstallation").className = "loader hidden"

              console.log("Información cargada correctamente")
            }
          }
    
          if (this.readyState === 4 && this.status !== 200) {  
            document.getElementById("loaderShareInstallation").className = "loader hidden"
            initialConfigCommonJS.mostrarMensajeInformativo('Se produjo un error al cargar la configuracion.',"negative")
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
          }

          document.getElementById("resultadoBusqueda").className = document.getElementById("resultadoBusqueda").className.replaceAll(" hidden", "")

        }
        xhttp.send(data);      
    }
    else{
      initialConfigCommonJS.mostrarMensajeInformativo('La cadena de búsqueda debe ser al menos de 4 caracteres.',"negative")
    }
  }

  return (          
    
    <main id="divMainContenedorStep">      

      <section id="shareInstallation" className="step">

        <div id="divContenedorStep" className="content-wrapper">          

          <div className="message info left">            
            <p>Podrá consultar la información básica de tu instalación y definir reglas/alertas. En ningún caso modificar tu instalación ni controlar ninguno de tus dispositivos.</p>
          </div>

          <fieldset>
            <fieldset className="search submit">
              <input type="search" id="textoBuscador" placeholder="Buscar empresa..." spellCheck="false" autoCorrect="off" autoComplete="off" onKeyDown={handleKeyDown}/>
              <button className="button secondary size-s clear" onClick={() => dashboardCommonJS.inicializarCajaBusqueda("textoBuscador","BUSCADOR_INSTALADORES")}><span className="material-icon">clear</span></button>
              <button className="button primary size-s" onClick={() => buscarInstalador()}><span className="material-icon">search</span></button>
            </fieldset>
          </fieldset>

          <div id="resultadoBusqueda" className="accordion-wrapper">
            <InstallersList listadoInstaladores={listadoInstaladores} seleccionarOpcionSharing={params.seleccionarOpcionSharing}/>
          </div>
          
        </div>

        <Loader Id="loaderShareInstallation" Mensaje=""/>

      </section>

    </main>
    
  )
}

export default ShareWithInstaller